// L'EFFACEUR — Bannière "Vérifie ton email" sur dashboard client

import { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { motion, AnimatePresence } from 'framer-motion';
import { Mail, X, Send } from 'lucide-react';
import { API } from '../../App';
import { Button } from '../ui/button';

const EmailVerificationBanner = () => {
  const [show, setShow] = useState(false);
  const [user, setUser] = useState(null);
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  useEffect(() => {
    const fetchMe = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) return;
        const res = await axios.get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } });
        // /auth/me retourne {user: {...}, ...root_fields} → on prend l'objet user
        const userObj = res.data.user || res.data;
        setUser(userObj);
        // Affiche la bannière uniquement si email pas vérifié ET non masquée
        const dismissed = sessionStorage.getItem('email_verify_dismissed');
        if (!userObj.email_verified && !dismissed && userObj.email) setShow(true);
      } catch {}
    };
    fetchMe();
  }, []);

  const sendVerification = async () => {
    setSending(true);
    try {
      const token = localStorage.getItem('token');
      await axios.post(`${API}/security/send-verification-email`, {}, { headers: { Authorization: `Bearer ${token}` } });
      setSent(true);
      toast.success('Email envoyé. Vérifie ta boîte (et les spams).');
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Erreur envoi');
    } finally {
      setSending(false);
    }
  };

  const dismiss = () => {
    sessionStorage.setItem('email_verify_dismissed', '1');
    setShow(false);
  };

  if (!show || !user) return null;

  // CCC.6 : version compacte, single-line, claire.
  // Avant : texte verbeux "Email de confirmation envoyé à leffaceur@effaceurpro.fr"
  // qui était confus parce qu'il affichait l'email du user lui-même.
  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -10 }}
        className="border-l-2 border-orange-400/60 bg-orange-400/5 px-4 py-2.5 mb-3 rounded-r-md flex items-center gap-3"
      >
        <Mail className="w-4 h-4 text-orange-400 shrink-0" />
        <div className="flex-1 min-w-0 text-xs">
          {sent ? (
            <span className="text-orange-300">
              Email envoyé. Clique sur le lien (vérifie aussi tes spams).
            </span>
          ) : (
            <span className="text-gray-300">
              <span className="text-orange-300 font-bold">Vérifie ton email</span>
              {' '}pour recevoir les notifications de mission.
            </span>
          )}
        </div>
        {!sent && (
          <button
            onClick={sendVerification}
            disabled={sending}
            className="text-xs text-orange-400 hover:text-orange-300 font-bold whitespace-nowrap underline-offset-2 hover:underline"
          >
            {sending ? 'Envoi...' : 'Renvoyer le lien'}
          </button>
        )}
        <button onClick={dismiss} className="text-gray-500 hover:text-white shrink-0">
          <X className="w-3.5 h-3.5" />
        </button>
      </motion.div>
    </AnimatePresence>
  );
};

export default EmailVerificationBanner;
